// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { HelmetProvider } from 'react-helmet-async';

import Header from './components/Header';
import HeaderPublic from './components/Header/HeaderPublic';
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import ForgetPassword from './pages/auth/ForgetPassword';
import Dashboard from './pages/Dashboard';
import AdminPanel from './pages/AdminPanel';
import Settings from './pages/Settings';
import Membership from './pages/auth/Membership';
import LandingPage from './pages/LandingPage';
import AuthGuard from './components/auth/AuthGuard';
import AdminGuard from './components/auth/AdminGuard';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from './services/firebase/config';
import { CurrencyProvider } from './contexts/CurrencyContext';
import AccountDetail from './pages/account/AccountDetail';

// Ödeme sayfası bileşenleri
import PaymentPage from './pages/payment/PaymentPage';
import PaymentSuccess from './pages/payment/PaymentSuccess';
import PaymentFailed from './pages/payment/PaymentFailed';
import PaymentCallback from './pages/payment/callback';
import PaymentTestPage from './pages/payment/PaymentTestPage';

import ImportData from './pages/importData';
import Support from './pages/support';
import Contact from './pages/contact';

import GettingStarted from './pages/support/getting-started';
import SupportPortfolioManagement from './pages/support/portfolio-management';
import Security from './pages/support/security';
import Payment from './pages/support/payment';
import { PortfolioProvider } from './contexts/PortfolioContext';
 
import PortfolioManagement from './pages/PortfolioManagement';
import RebalanceSettingsPage from './pages/RebalanceSettingsPage';

import PortfolioPositionsPage from './pages/PortfolioPositionsPage';
 

import FinancialFormulas from './pages/tools/FinancialFormulas'

 import  RebalanceGuide from './pages/education/rebalance-guide'

 import InvestingMistakes from './pages/education/investing-mistakes'
 
 import PiotroskiScoreGuide from './pages/education/piotroski-score-guide'


 import BalanceSheetVsPnL from './pages/education/balance-sheet-pnl'

 import HisseBasinaKazanc from './pages/education/hisse-basina-kazanc'

 import TheImpactOfInterestRates from './pages/education/the-impact-of-interest-rates'

 import EconomicIndicators from './pages/education/economic-indicators'
 

 import RiskTolerance from './pages/education/risk-tolerance';

 import BasicFinancialRatios from './pages/education/basic-financial-ratios';



 import ETFs from './pages/education/etfs';

 import FinancialNews from './pages/financial-news';

 import Gainers from './pages/markets/gainers';
 
 
  import Losers from './pages/markets/losers';

  import MostActives  from './pages/markets/most-actives';

  import SectorPerformance from './pages/markets/sector-performance';

  import Cryptocurrencies from './pages/markets/cryptocurrencies';

  import ForexRates from './pages/markets/forex-rates';


  import SlingshotSignals from './pages/patterns/SlingshotSignals';

import BlogManagement from './admin/pages/blog/BlogManagement';
import CreateArticle from './admin/pages/blog/CreateArticle';
import EditArticle from './admin/pages/blog/EditArticle';

import ArticleView from './pages/education/ArticleView';

import BlogListing from './pages/education/BlogListing';

import BasicEducation from './pages/education/BasicEducation';

const PageWrapper = ({ children }) => (
  <PortfolioProvider>
    <CurrencyProvider>
      <div className="min-h-screen bg-white dark:bg-[#0A0E23]">
        <Toaster
          position="top-right"
          toastOptions={{
            className: '',
            duration: 3000,
            style: {
              background: '#fff',
              color: '#363636',
            },
            success: {
              duration: 3000,
              theme: {
                primary: '#4CAF50',
              },
            },
            error: {
              duration: 4000,
              theme: {
                primary: '#E53E3E',
              },
            },
          }}
        />
        <Header />
        {children}
      </div>
    </CurrencyProvider>
  </PortfolioProvider>
);




const PublicWrapper = ({ children }) => (
  <div className="min-h-screen bg-white dark:bg-[#0A0E23]">
    <Toaster
      position="top-right"
      toastOptions={{
        className: '',
        duration: 3000,
        style: {
          background: '#fff',
          color: '#363636',
        },
        success: {
          duration: 3000,
          theme: {
            primary: '#4CAF50',
          },
        },
        error: {
          duration: 4000,
          theme: {
            primary: '#E53E3E',
          },
        },
      }}
    />
    <HeaderPublic />
    {children}
  </div>
);

function App() {
  const [user] = useAuthState(auth);

  return (
    <HelmetProvider>
      <Router>
        <Routes>
          {/* Ana sayfa yönlendirmesi */}
          <Route path="/" element={
            user ? <Navigate to="/dashboard" replace /> : 
            <PublicWrapper>
              <LandingPage />
            </PublicWrapper>
          } />

          {/* Public Routes */}
          <Route path="/login" element={
            user ? <Navigate to="/dashboard" replace /> : 
            <PublicWrapper>
              <Login />
            </PublicWrapper>
          } />
          
          <Route path="/register" element={
            user ? <Navigate to="/dashboard" replace /> : 
            <PublicWrapper>
              <Register />
            </PublicWrapper>
          } />



          <Route path="/forgot-password" element={
            user ? <Navigate to="/dashboard" replace /> : 
            <PublicWrapper>
              <ForgetPassword />
            </PublicWrapper>
          } />

          {/* Protected Routes */}
          <Route path="/dashboard" element={
            <AuthGuard>
              <PageWrapper>
                <Dashboard />
              </PageWrapper>
            </AuthGuard>
          } />

          <Route path="/settings" element={
            <AuthGuard>
              <PageWrapper>
                <Settings />
              </PageWrapper>
            </AuthGuard>
          } />

        <Route path="/portfolio/positions" element={
          <AuthGuard>
              <PageWrapper>

              <PortfolioPositionsPage />
              </PageWrapper>
      
          </AuthGuard>
        } />

          <Route path="/admin" element={
            <AdminGuard>
              <PageWrapper>
                <AdminPanel />
              </PageWrapper>
            </AdminGuard>
          } />

          <Route path="/membership" element={
            <PublicWrapper>
              <Membership />
            </PublicWrapper>
          } />

          {/* Payment Routes */}
          <Route path="/payment" element={
            <AuthGuard>
              <PageWrapper>
                <PaymentPage />
              </PageWrapper>
            </AuthGuard>
          } />

          <Route path="/payment/success" element={
            <PublicWrapper>
              <PaymentSuccess />
            </PublicWrapper>
          } />

          <Route path="/payment/failed" element={
            <AuthGuard>
              <PageWrapper>
                <PaymentFailed />
              </PageWrapper>
            </AuthGuard>
          } />

          <Route path="/importData" element={
            <AuthGuard>
              <PageWrapper>
                <ImportData />
              </PageWrapper>
            </AuthGuard>
          } />

          <Route path="/support" element={
            user ? (
              <PageWrapper>
                <Support />
              </PageWrapper>
            ) : (
              <PublicWrapper>
                <Support />
              </PublicWrapper>
            )
          } />

          <Route path="/contact" element={
            <PublicWrapper>
              <Contact />
            </PublicWrapper>
          } />

        <Route path="/egitim/finansal-formuller" element={
            <PublicWrapper>
              <FinancialFormulas  />
            </PublicWrapper>
          } />      

  <Route path="/egitim/yeniden-dengeleme-rehberi" element={
            <PublicWrapper>
              <RebalanceGuide  />
            </PublicWrapper>
          } /> 

  <Route path="/egitim/yatirim-hatalari" element={
            <PublicWrapper>
              <InvestingMistakes  />
            </PublicWrapper>
          } /> 


  <Route path="/egitim/piotroski-puani" element={
            <PublicWrapper>
              <PiotroskiScoreGuide  />
            </PublicWrapper>
          } /> 
       
       <Route path="/egitim/bilanco-kar-zarar-tablosu" element={
            <PublicWrapper>
              <BalanceSheetVsPnL  />
            </PublicWrapper>
          } /> 
       
       <Route path="/egitim/hisse-basina-kazanc" element={
            <PublicWrapper>
              <HisseBasinaKazanc  />
            </PublicWrapper>
          } /> 
       

       <Route path="/egitim/faiz-oranlarinin-etkisi" element={
            <PublicWrapper>
              <TheImpactOfInterestRates  />
            </PublicWrapper>
          } /> 


  <Route path="/egitim/ekonomik-gostergeler" element={
            <PublicWrapper>
              <EconomicIndicators  />
            </PublicWrapper>
          } /> 

  <Route path="/egitim/risk-toleransi" element={
            <PublicWrapper>
              <RiskTolerance/>
            </PublicWrapper>
          } /> 

  <Route path="/egitim/etfs" element={
            <PublicWrapper>
              <ETFs/>
            </PublicWrapper>
          } /> 



  <Route path="/egitim/temel-finansal-oranlar" element={
            <PublicWrapper>
              <BasicFinancialRatios/>
            </PublicWrapper>
          } /> 


  <Route path="/global-haberler" element={
            <PublicWrapper>
              <FinancialNews/>
            </PublicWrapper>
          } /> 



  <Route path="/piyasalar/en-cok-kazananlar" element={
            <PublicWrapper>
              <Gainers/>
            </PublicWrapper>
          } /> 


  <Route path="/piyasalar/en-cok-kaybedenler" element={
            <PublicWrapper>
              <Losers/>
            </PublicWrapper>
          } /> 

  <Route path="/piyasalar/en-yuksek-hacimliler" element={
            <PublicWrapper>
              <MostActives />
            </PublicWrapper>
          } /> 
   

   <Route path="/piyasalar/sektor-performanslari" element={
            <PublicWrapper>
              <SectorPerformance />
            </PublicWrapper>
          } /> 
   
   <Route path="/piyasalar/kriptopara" element={
            <PublicWrapper>
              <Cryptocurrencies />
            </PublicWrapper>
          } /> 
   

   <Route path="/piyasalar/doviz-kurlari" element={
            <PublicWrapper>
              <ForexRates />
            </PublicWrapper>
          } /> 


  <Route path="/sinyaller/sapan-sinyalleri" element={
            <PublicWrapper>
              <SlingshotSignals/>
            </PublicWrapper>
          } /> 



          <Route path="/payment/callback" element={
            <PublicWrapper>
              <PaymentCallback />
            </PublicWrapper>
          } />

          <Route path="/payment/test" element={
            <PublicWrapper>
              <PaymentTestPage />
            </PublicWrapper>
          } />

          <Route path="/account/settings" element={
            <AuthGuard>
              <PageWrapper>
                <AccountDetail />
              </PageWrapper>
            </AuthGuard>
          } />

          <Route path="/support/getting-started" element={
            user ? (
              <PageWrapper>
                <GettingStarted />
              </PageWrapper>
            ) : (
              <PublicWrapper>
                <GettingStarted />
              </PublicWrapper>
            )
          } />

          <Route path="/support/portfolio-management" element={
            user ? (
              <PageWrapper>
                <SupportPortfolioManagement />
              </PageWrapper>
            ) : (
              <PublicWrapper>
                <PortfolioManagement />
              </PublicWrapper>
            )
          } />

          <Route path="/support/security" element={
            user ? (
              <PageWrapper>
                <Security />
              </PageWrapper>
            ) : (
              <PublicWrapper>
                <Security />
              </PublicWrapper>
            )
          } />

          <Route path="/support/payment" element={
            user ? (
              <PageWrapper>
                <Payment />
              </PageWrapper>
            ) : (
              <PublicWrapper>
                <Payment />
              </PublicWrapper>
            )
          } />

  

  <Route path="/portfolio-management" element={
    <AuthGuard>
      <PageWrapper>
        <PortfolioManagement />
      </PageWrapper>
    </AuthGuard>
  } />

  <Route path="/rebalance-settings" element={
    <AuthGuard>
      <PageWrapper>
        <RebalanceSettingsPage />
      </PageWrapper>
    </AuthGuard>
  } />

  <Route path="/admin/blog" element={
    <PublicWrapper>
      <BlogManagement />
    </PublicWrapper>
  } />

  <Route path="/admin/blog/create" element={
    <PublicWrapper>
      <CreateArticle />
    </PublicWrapper>
  } />

  <Route path="/admin/blog/edit/:id" element={
    <PublicWrapper>
      <EditArticle />
    </PublicWrapper>
  } />

  <Route path="/egitim/:slug" element={
    <PublicWrapper>
      <ArticleView />
    </PublicWrapper>
  } />

  <Route path="/egitim" element={
    <PublicWrapper>
      <BlogListing />
    </PublicWrapper>
  } />

  <Route path="/egitim/temel-egitimler" element={
    <PublicWrapper>
      <BasicEducation />
    </PublicWrapper>
  } />

   
   
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;